module.exports = require("./Tab");